export default (
  {
    adaptiveHeight: true,
    autoPlay: 7500,
    draggable: false,
    fade: true,
    groupCells: false,
    imagesLoaded: true,
    pageDots: true,
    prevNextButtons: false
  }
);
